/* eslint-disable complexity */
import React from "react"
import { useTranslation } from "react-i18next"
import { CSSTransition } from "react-transition-group"

import { useAppData } from "~/api/globals"
import { Title } from "~/components/Helpers/Title/Title"
import { useExportMagLang } from "~/components/LanguageProvider/LanguageProvider"
import { LazyImage } from "~/components/LazyImage/LazyImage"
import { RouterLink } from "~/components/RouterLink/RouterLink"
import { TiltCard } from "~/components/TiltCard/TiltCard"

import { MenuLink } from "../../../MenuLink/MenuLink"
import styles from "./index.module.css"

const Transition = ({ children, isOpen, enterTimeout }) => (
  <CSSTransition
    classNames={{
      enter: styles.Enter,
      enterDone: styles.EnterDone,
      exit: styles.Exit,
    }}
    in={isOpen}
    timeout={{ enter: enterTimeout, exit: 220 }}
    unmountOnExit
  >
    {children}
  </CSSTransition>
)
export const Portfolio = ({ isOpen, menuItems }) => {
  const { i18n } = useTranslation()
  const { exportMagLang } = useExportMagLang()
  const currLang = exportMagLang ? exportMagLang : i18n.language
  const context = useAppData()

  const menuCase =
    context && context.menu && Array.isArray(context.menu.case) && context.menu.case.length !== 0
      ? context.menu.case[0]
      : null

  return (
    <div className={styles.Wrapper}>
      {menuItems.map((array, i) => (
        <div key={i}>
          {array.map(({ slug, title }, j) => (
            <Transition key={j} enterTimeout={110 * j + i * 55} isOpen={isOpen}>
              <MenuLink as={`/service/${slug}`} href={`/service/[slug]`}>
                <span>{title}</span>
              </MenuLink>
            </Transition>
          ))}
          {i === 1 && (
            <Transition enterTimeout={110 * 3 + i * 55} isOpen={isOpen}>
              <MenuLink as={"/cases"} href={"/cases"}>
                <span style={{ whiteSpace: "nowrap" }}>
                  {currLang === "ru" ? "Все проекты" : "All"}
                </span>
              </MenuLink>
            </Transition>
          )}
        </div>
      ))}

      {menuCase && (
        <Transition enterTimeout={250} isOpen={isOpen}>
          <RouterLink className={styles.Item} href={menuCase.link}>
            <div className={styles.Image}>
              <TiltCard>
                <LazyImage
                  placeholderSrc={menuCase.image.blur_ImageWideLarge}
                  src={menuCase.image.ImageWideLarge}
                />
              </TiltCard>
            </div>
            {menuCase.services && menuCase.services.length !== 0 ? (
              <div>{menuCase.services[0].title}</div>
            ) : null}
            <Title type={"h3"}>{`${menuCase.shortTitle}`}</Title>
          </RouterLink>
        </Transition>
      )}
    </div>
  )
}
